import { render, staticRenderFns } from "./CardMiniBeacon.vue?vue&type=template&id=8015117a&scoped=true&"
import script from "./CardMiniBeacon.vue?vue&type=script&lang=js&"
export * from "./CardMiniBeacon.vue?vue&type=script&lang=js&"
import style0 from "./CardMiniBeacon.vue?vue&type=style&index=0&id=8015117a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8015117a",
  null
  
)

export default component.exports